import { gql } from '@apollo/client';

const GET_ORDERING_COMPANIES = gql`query getOrderingCompanies($searchTerm: String!){
	incomingOrdersContext
	{
		searchOrderingCompany(search: $searchTerm)
		{
			companyId
			name
		}
	}
}`;

export default GET_ORDERING_COMPANIES;